"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getDefaultJobAndCompanyPromptData = exports.interpolateTemplate = void 0;
const lodash_1 = require("lodash");
const job_1 = require("../models/job");
function mapVars(vars) {
    const snakeCased = (0, lodash_1.mapKeys)(vars, (_1, key) => (0, lodash_1.snakeCase)(key));
    const camelCased = (0, lodash_1.mapKeys)(vars, (_1, key) => (0, lodash_1.camelCase)(key));
    return Object.assign(Object.assign({}, snakeCased), camelCased);
}
function interpolateTemplate(templateString, vars) {
    const ignoredStrings = ['{{Sender Signature}}', '{{First Name}}'];
    const updatedTemplate = ignoredStrings.reduce((acc, ignoredString) => acc.replace(new RegExp(ignoredString, 'g'), ignoredString.replace(/{{/g, '<<').replace(/}}/g, '>>')), templateString);
    const mappedVars = mapVars(vars);
    let result = (0, lodash_1.template)(updatedTemplate, {
        evaluate: /\[\%([\s\S]+?)\%\]/g,
        interpolate: /{{([\s\S]+?)}}/g
    })(mappedVars);
    result = ignoredStrings.reduce((acc, ignoredString) => acc.replace(new RegExp(ignoredString.replace(/{{/g, '<<').replace(/}}/g, '>>'), 'g'), ignoredString), result);
    return result;
}
exports.interpolateTemplate = interpolateTemplate;
function getDefaultJobAndCompanyPromptData(job, client) {
    var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k, _l, _m, _o, _p, _q, _r, _s, _t, _u, _v, _w, _x, _y, _z, _0, _2;
    const clientDescription = ((_a = client.description) !== null && _a !== void 0 ? _a : '').trim();
    const clientSellingPoints = ((_b = client.salesPitch) !== null && _b !== void 0 ? _b : '').trim();
    const clientFoundedDate = ((_c = client.foundedDate) !== null && _c !== void 0 ? _c : '').trim();
    const clientFounders = ((_d = client.founders) !== null && _d !== void 0 ? _d : '')
        .trim()
        .split(',')
        .map((f) => f.trim())
        .join(', ');
    const clientFunding = ((_e = client.funding) !== null && _e !== void 0 ? _e : '').trim();
    const clientHQ = ((_f = client.hq) !== null && _f !== void 0 ? _f : '').trim();
    const clientTeamSize = ((_g = client.teamSize) !== null && _g !== void 0 ? _g : '').trim();
    const clientWebsite = ((_h = client.website) !== null && _h !== void 0 ? _h : '').trim();
    const clientInfoParts = [clientDescription];
    if (clientSellingPoints) {
        clientInfoParts.push(`Memorable Selling Points: ${clientSellingPoints}`);
    }
    if (clientFoundedDate) {
        clientInfoParts.push(`Founded: ${clientFoundedDate}`);
    }
    if (clientFounders) {
        clientInfoParts.push(`Founders: ${clientFounders}`);
    }
    if (clientFunding) {
        clientInfoParts.push(`Funding: ${clientFunding}`);
    }
    if (clientHQ) {
        clientInfoParts.push(`HQ: ${clientHQ}`);
    }
    if (clientTeamSize) {
        clientInfoParts.push(`Team Size: ${clientTeamSize}`);
    }
    if (clientWebsite) {
        clientInfoParts.push(`Website: ${clientWebsite}`);
    }
    const companyInformation = clientInfoParts.join('\n\n') + '\n';
    const jd = ((_j = job.description.description) !== null && _j !== void 0 ? _j : '').trim();
    const jobTitle = job.title;
    const jdYears = [(_k = job.description) === null || _k === void 0 ? void 0 : _k.minExperienceYears, (_l = job.description) === null || _l === void 0 ? void 0 : _l.maxExperienceYears]
        .filter((x) => x)
        .join(' - ');
    const jdLocation = (_p = (_o = (_m = job.description) === null || _m === void 0 ? void 0 : _m.location) === null || _o === void 0 ? void 0 : _o.trim()) !== null && _p !== void 0 ? _p : '';
    const compensation = (_r = (_q = job.description) === null || _q === void 0 ? void 0 : _q.compensation) !== null && _r !== void 0 ? _r : '';
    const visa = (_w = (_v = (_u = (_t = (_s = job.description) === null || _s === void 0 ? void 0 : _s.visa) === null || _t === void 0 ? void 0 : _t.map(job_1.visaOptToString)) === null || _u === void 0 ? void 0 : _u.join(', ')) === null || _v === void 0 ? void 0 : _v.trim()) !== null && _w !== void 0 ? _w : '';
    const hiringManager = (_z = (_y = (_x = job.description) === null || _x === void 0 ? void 0 : _x.hiringManager) === null || _y === void 0 ? void 0 : _y.trim()) !== null && _z !== void 0 ? _z : '';
    const interviewPrep = ((_2 = (_0 = job.description) === null || _0 === void 0 ? void 0 : _0.interviewPrep) !== null && _2 !== void 0 ? _2 : '').trim();
    const jdParts = [];
    if (jobTitle) {
        jdParts.push(`Job Title: ${jobTitle}`);
    }
    if (jdYears) {
        jdParts.push(`Experience: ${jdYears} years`);
    }
    if (jdLocation) {
        jdParts.push(`Location: ${jdLocation}`);
    }
    if (compensation) {
        jdParts.push(`Compensation: ${compensation}`);
    }
    if (visa) {
        jdParts.push(`Visa: ${visa}`);
    }
    if (hiringManager) {
        jdParts.push(`Hiring Manager: ${hiringManager}`);
    }
    if (interviewPrep) {
        jdParts.push(`Interview Process:\n${interviewPrep}`);
    }
    if (jd) {
        jdParts.push(`Detailed Job Description:\n${jd}`);
    }
    const jobDescription = jdParts.join('\n\n') + '\n';
    return {
        companyInformation,
        jobDescription
    };
}
exports.getDefaultJobAndCompanyPromptData = getDefaultJobAndCompanyPromptData;
//# sourceMappingURL=llm.js.map